import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../../../environments/environment';
import { YouTubePlayerComponent } from '../../../core/shared/components/youtube-player/youtube-player.component';

@Component({
  selector: 'app-video-modal',
  standalone: true,
  imports: [CommonModule, YouTubePlayerComponent],
  templateUrl: './video-modal.component.html',
  styleUrl: './video-modal.component.scss'
})
export class VideoModalComponent implements OnChanges, AfterViewInit {
  @Input() isVisible: boolean = false;
  @Output() closeDialogEvent = new EventEmitter<void>();
  @ViewChild('youtubePlayer', { static: false }) youtubePlayer!: ElementRef;

  videoUrl: string = environment.urlVideo;

  ngAfterViewInit(): void {
    // Esperar a que el DOM esté listo
    setTimeout(() => {
      this.checkAndControlVideo();
    }, 100);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isVisible'] && changes['isVisible'].currentValue) {
      // Cuando el modal se abre, esperar un poco y luego reproducir el video
      setTimeout(() => {
        this.playVideo();
      }, 300);
    } else if (changes['isVisible'] && !changes['isVisible'].currentValue) {
      // Cuando el modal se cierra, detener el video
      this.stopVideo();
    }
  }

  closeDialog(): void {
    this.closeDialogEvent.emit();
  }

  // Método para obtener el ID del video usando el componente existente
  getVideoId(): string {
    return YouTubePlayerComponent.extractVideoId(this.videoUrl) || '';
  }

  // Método para obtener parámetros de autoplay
  getVideoParams(): string {
    return 'autoplay=1&mute=0&enablejsapi=1&origin=' + window.location.origin + '&rel=0&showinfo=0';
  }

  // Método para reproducir el video automáticamente
  private playVideo(): void {
    try {
      const liteYoutubeElement = this.findLiteYoutubeElement();
      if (liteYoutubeElement) {
        // Simular clic en el elemento lite-youtube para reproducir
        liteYoutubeElement.click();
        console.log('Video iniciado automáticamente');
        
        // También intentar reproducir usando el API de YouTube
        setTimeout(() => {
          this.forcePlayVideo();
        }, 500);
      }
    } catch (error) {
      console.warn('No se pudo reproducir el video automáticamente:', error);
    }
  }

  // Método para forzar la reproducción del video
  private forcePlayVideo(): void {
    try {
      const iframe = this.findYouTubeIframe();
      if (iframe && iframe.contentWindow) {
        // Enviar comando para reproducir el video
        iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        console.log('Comando de reproducción enviado al iframe');
      }
    } catch (error) {
      console.warn('No se pudo forzar la reproducción:', error);
    }
  }

  // Método para detener el video
  private stopVideo(): void {
    try {
      const iframe = this.findYouTubeIframe();
      if (iframe && iframe.contentWindow) {
        // Enviar comando para detener el video
        iframe.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
        console.log('Video detenido');
      }
    } catch (error) {
      console.warn('No se pudo detener el video:', error);
    }
  }

  // Método para encontrar el iframe de YouTube
  private findYouTubeIframe(): HTMLIFrameElement | null {
    if (this.youtubePlayer?.nativeElement) {
      return this.youtubePlayer.nativeElement.querySelector('iframe');
    }
    return document.querySelector('iframe[src*="youtube.com"]');
  }

  // Método para encontrar el elemento lite-youtube
  private findLiteYoutubeElement(): HTMLElement | null {
    if (this.youtubePlayer?.nativeElement) {
      return this.youtubePlayer.nativeElement.querySelector('lite-youtube');
    }
    return document.querySelector('lite-youtube');
  }

  // Método para verificar y controlar el video
  private checkAndControlVideo(): void {
    if (this.isVisible) {
      this.playVideo();
    }
  }
}
